import { Modal, Button, Spin } from 'antd';
import React, { Component } from 'react';
import './styles.css';
import { getImportHistoryOrders } from './../../../utils/orders';
import hanldeException from './../../../services/handleException';
import { iconEmpty } from './../../../services/helper';
import ImportHistoryDetail from './detail.js';
import { convertDateFromUTC } from './../../../services/dst';
import { getImageChannel, ImportType } from './../../../constants/order';

class ImportHistoryOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ihdVisible: false, // import history detail popup
            items: [], // list import history
            objItem: {}, // history detail clicked
            isLoaded: 0, // 0: not load, 1: loaded, 2: loading, 3: load end data
        };
        this.limit = {
            default: 10,
            next: 50,
        }
        this.params = {
            limit: this.limit.default
        }
    }

    /**
     * relset item, loaded when mount new component
     */
    resetLoaded() {
        this.setState({
            items: [],
            isLoaded: 0,
        });
        this.params = {
            limit: this.limit.default
        }
    }

    componentDidMount() {
        this.callImportHistoryOrders();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.isVisible !== this.props.isVisible && this.props.isVisible === true) {
            this.resetLoaded();
            setTimeout(() => {
                this.callImportHistoryOrders();
            });
        }
    }

    /**
     * call ajax get order import history
     */
    callImportHistoryOrders = () => {
        let that = this;
        if (that.state.isLoaded === 2 || that.state.isLoaded === 3) {
            return true;
        }
        that.setState({
            isLoaded: 2
        });
        getImportHistoryOrders({
            offset: that.state.items.length,
            limit: that.params.limit,
        })
        .then(response => {
            if (response.data.code === 10001) {
                that.setState({
                    items: that.state.items.concat(response.data.data)
                });
            } else {
                hanldeException(response);
            }
            if (response.data.data.length < that.params.limit) { // end data
                that.setState({
                    isLoaded: 3
                });
            } else {
                that.setState({
                    isLoaded: 1
                });
            }
            that.params.limit = that.limit.next;
        })
        .catch(error => {
            that.setState({
                isLoaded: 1
            });
            hanldeException(error);
        });
    }

    /**
     * handle click order import detail
     */
    clickDetailImport = (e, objItem) => {
        let apiRow = true;
        this.setState({
            ihdVisible: apiRow,
            objItem: objItem,
        });
    }

    /**
     * Handle close popup import history detail
     */
    closeImportHistoryDetail = (e) => {
        this.setState({
            ihdVisible: false,
        });
    }

    /**
     * scroll import history event
     */
    scrollImportHistory = (e) => {
        let isBottom = (e.target.scrollHeight -  e.target.scrollTop === e.target.clientHeight);
        if (!isBottom) {
            return true;
        }
        this.callImportHistoryOrders();
    }

    /**
     * render a row in table
     */
    renderRows() {
        return (
            this.state.items.map((item, index) => {
                return (
                    <tr key={index} onClick={e => this.clickDetailImport(e, item)} >
                        <td className="col-date">
                            {convertDateFromUTC(item.ImportDatetime).format('MM/DD/YYYY HH:mm:ss')}
                        </td>
                        <td className="col-chanel">
                            {getImageChannel(item.ChannelName)}
                        </td>
                        <td className="text-center text-up col-type">{ImportType[item.Type]}</td>
                        <td className="text-center col-order">{item.OrderCount}</td>
                        <td className="text-center col-import">{item.ImportCount}</td>
                        <td className={"text-center col-warning" + (item.WarningCount > 0 ? ' color-black' : '')}>{item.WarningCount}</td>
                        <td className={"text-center col-fatal" + (item.FatalCount > 0 ? ' color-red' : '')}>{item.FatalCount}</td>
                    </tr>
                )
            })
        );
    }

    /**
     * render row empty
     */
    renderEmpty() {
        if (this.state.isLoaded === 1 || this.state.isLoaded === 3) {
            return (
                <tr className="tr-empty">
                    <td colSpan={8}>
                        {iconEmpty()}
                    </td>
                </tr>
            );
        }
        return;
    }

    render() {
        return (
            <div>
                <h2 className="ih-title">Import History</h2>
                <table className="tbl-import-history">
                    <thead>
                        <tr className="tr-first-head">
                            <th colSpan="5">&nbsp;</th>
                            <th colSpan="2" className="col-error text-center">Errors</th>
                        </tr>
                        <tr className="tr-2-head">
                            <th className="col-date">Import Date Time</th>
                            <th className="col-chanel">Channel</th>
                            <th className="col-type text-center">Type</th>
                            <th className="col-order text-center">Order Count</th>
                            <th className="col-import text-center">Import Count</th>
                            <th className="col-warning text-center">Warning Count</th>
                            <th className="col-fatal text-center">Fatal Count</th>
                        </tr>
                    </thead>
                    <tbody onScroll={e => this.scrollImportHistory(e)}>
                        {this.state.items.length ? this.renderRows() : this.renderEmpty()}
                        <tr className={"tr-empty" + (this.state.isLoaded === 1 || this.state.isLoaded === 3 ? ' hidden' : '')}>
                            <td colSpan={8}>
                                <Spin />
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* popup show detail import history */}
                <Modal
                    title={ImportType[this.state.objItem.Type] + " import result - detail"}
                    visible={this.state.ihdVisible}
                    maskClosable={false}
                    className="modal-history modal-import-order"
                    centered={true}
                    onCancel={this.closeImportHistoryDetail}
                    footer={[
                        <Button className="btn-opt" key="submit" type="primary" onClick={this.closeImportHistoryDetail}>
                          OK
                        </Button>
                    ]}
                >
                    <ImportHistoryDetail 
                        objItem={this.state.objItem} 
                        isVisible={this.state.ihdVisible}
                    />
                </Modal>
            </div>
        );
    }
}

export default ImportHistoryOrder;


// WEBPACK FOOTER //
// ./src/containers/orders/importHistory/index.js